
import React from "react";
import { CheckCircle } from "lucide-react";

// WhatsApp Leads Data
const whatsappLeadsData = [
  {
    heading: "Automate IT Support & Helpdesk",
    points: [
      "Handle common tech questions with WhatsApp chatbots.",
      "Solve software glitches and FAQs automatically.",
      "Pass tricky issues to live agents anytime, day or night.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/35vbur4y266w8yw3.jpg",
  },
  {
    heading: "Onboard Users with Ease",
    points: [
      "Guide new users step-by-step via WhatsApp automation.",
      "Share handy video tutorials for smooth setup.",
      "Keep users engaged with ongoing support messages.",
    ],
    // buttonText: "Get Start ",
    image: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/eyin2ni1kpi9znh8.png",
  },
  {
    heading: "Send Real-Time Alerts",
    points: [
      "Notify users instantly about downtime or breaches.",
      "Keep clients in the loop with server updates.",
      "Build trust with clear, timely communication.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/f2277416vydlvdqh.png",
  },
  {
    heading: "Grow Leads & Qualify Prospects",
    points: [
      "Capture leads easily with WhatsApp chatbots.",
      "Ask smart questions to qualify prospects fast.",
      "Hand off hot leads to your sales team seamlessly.",
    ],
    buttonText: "Meta Policy for Information Technology Services",
    buttonLink:"https://transparency.meta.com/policies/ad-standards/",
    // buttonText: "Get Start ",
    image: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/74k9k62fagqa8pkr.png",
  },
  {
    heading: "Manage Licenses & Renewals",
    points: [
      "Send friendly renewal reminders on WhatsApp.",
      "Alert users about subscription deadlines.",
      "Keep customers updated with new features.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/4j8ywvvbd4zlcpts.webp",
  },
  {
    heading: "Boost Webinar & Demo Attendance",
    points: [
      "Invite users to demos with automated messages.",
      "Send reminders to ensure they don’t miss out.",
      "Share links for easy access to sessions.",
    ],
    // buttonText: "Get Start ",
    image: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/uzbr0pahuics40hu.jpg",
  },
];

const ITservicescycle = () => {
  return (
    <>
      <div className="bg-gradient-to-r from-blue-100 via-purple-200 to-indigo-100 py-12 px-6 text-center">
        <h1 className="text-4xl font-bold text-gray-900">How WhatsApp Fuels Tech Growth</h1>
        <div className="w-16 h-1 bg-gray-600 my-4 mx-auto rounded-full"></div>
        <p className="text-xl text-gray-800 max-w-3xl mx-auto">In a fast-moving IT world, WhatsApp helps startups, SaaS, and tech firms connect, support, and grow with ease.</p>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-20">
        {whatsappLeadsData.map((item, index) => (
          <div key={index} className={`flex flex-col lg:flex-row items-center gap-16 my-20 ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
            <div className="w-full lg:w-1/2">
              <img src={item.image} alt={item.heading} className="w-full h-auto rounded-lg shadow-md hover:scale-105 transition-transform" />
            </div>
            <div className="w-full lg:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">{item.heading}</h2>
              <ul className="space-y-4 text-gray-700">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
              {item.buttonText && (
                <a
                href={item.buttonLink}
                className="mt-6 inline-block bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors"
              >
                {item.buttonText}
              </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ITservicescycle;